import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import { isEmpty } from '../../utils/obj-utils';

function FormMessage({
    formRef,
    isSuccessMessage,
    messages
}) {
    const classType = isSuccessMessage ? '__success' : '__error';

    function displayFormMessages() {
        if (isEmpty(messages)) {
            return null;
        }

        const fieldClass = `form-field${classType}-item`;

        const messagesToDisplay = messages.map((m) => {
            return (<li key={uniqueId()}
                ref={formRef}
                className={fieldClass}>{m}</li>);
        });

        return (<Fragment >
            <ul className={`form-field${classType}-list filled`}>
                {messagesToDisplay}
            </ul>
        </Fragment>);
    }

    return displayFormMessages();
}

FormMessage.propTypes = {
    formRef: PropTypes.object,
    isSuccessMessage: PropTypes.bool.isRequired,
    messages: PropTypes.array,
};

export default FormMessage;
